import { useEffect } from "react";

// Lightweight SEO helper - sets title and meta tags without extra deps.
export default function SEO({
  title = "Quasect — SOC Level 2 Cybersecurity",
  description = "Quasect delivers SOC Level 2 cybersecurity, VAPT, threat protection, and 24/7 network monitoring for modern enterprises.",
  keywords = "SOC services, VAPT services, cybersecurity solutions, threat detection, network security monitoring, SOC level 2, penetration testing, vulnerability assessment",
  ogImage = "https://images.unsplash.com/photo-1751448555253-f39c06e29d82?w=1200",
  path = "/",
}) {
  useEffect(() => {
    document.title = title;
    const setMeta = (attr, name, content) => {
      let el = document.head.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", ogImage);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "theme-color", "#050507");

    // canonical
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", window.location.origin + path);

    // Schema
    const schemaId = "schema-org-jsonld";
    let s = document.getElementById(schemaId);
    if (!s) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = schemaId;
      document.head.appendChild(s);
    }
    s.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Quasect",
      alternateName: "Quasect Cybersecurity",
      url: window.location.origin,
      logo: `${window.location.origin}/logo-organization.png`,
      image: `${window.location.origin}/logo-organization.png`,
      email: "info@quasect.com",
      description,
      foundingDate: "2024",
      founders: [
        { "@type": "Person", name: "Sachin Deshpande" },
        { "@type": "Person", name: "Rahul Gawas" },
      ],
      sameAs: [],
      contactPoint: {
        "@type": "ContactPoint",
        contactType: "customer support",
        email: "info@quasect.com",
        availableLanguage: ["English"],
      },
    });
  }, [title, description, keywords, ogImage, path]);

  return null;
}
